// extracted by mini-css-extract-plugin
export default {"wrapper":"SideNav_wrapper__bhU6H","overlay":"SideNav_overlay__8zBx4"};